import styled from 'styled-components';

const BankInformationWrapper = styled.div<{ isHalfView: any }>`
  background-color: ${(props) => props.theme.color.neutral.v100};
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  border-radius: 8px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  // align-items: flex-end;
  padding: 24px;
  margin: 0 auto;
  max-width: 912px;
  width: 100%;
  flex-wrap: wrap;

  ${(props) =>
    !props.isHalfView &&
    `
    @media (min-width: 376px) {
      // &.paidOffLoan {
          // flex-wrap: wrap;
          flex-direction: row;
          align-items: flex-end;
      // }
    }
  `};
`;

const BridgecrestInformationWrapper = styled.div`
  display: flex;
  max-width: 400px;

  justify-content: flex-end;

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    margin-top: 24px;

    .paidOffLoan & {
      margin-top: 24px;
    }

    .activeLoan & {
      margin-top: 24px;
    }
  }

  // @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
  //   .activeLoan & {
  //     margin-top: 24px; );
  //   }
  // }
`;

const BankInformationDetailsContainer = styled.div<{ isHalfView: any }>`
  display: flex;
  flex-direction: ${(props) => {
    return props.isHalfView ? 'row' : 'column';
  }};
  flex-wrap: wrap;
`;

const BankInformationCardLabel = styled.h3`
  align-items: center;
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.color.primary.v400};
  padding: 0 0 16px 0;
  margin: 0;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  width: 100%;
`;

const BankInformationAccountNumberText = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: normal;
  font-size: 14px;
  display: flex;
  margin-top: 1px;
`;

const BankInformationDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    margin-bottom: 0px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0px;
    min-width: 315px;
  }
`;

const BankInformationDetails = styled.div`
  // max-width: 155px;
  max-width: 200px;
  justify-content: flex-start;
  margin-bottom: 24px;

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    min-width: 120px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    margin-right: 40px;
    margin-bottom: 0;

    .paidOffLoan & {
      margin-right: 40px;
    }

    .activeLoan & :first-child {
      margin-bottom: 24px;
    }

    .paidOffLoan &:first-child {
      margin-bottom: 24px;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    // margin-right: 40px;
    // margin-bottom: 0px;

    // .paidOffLoan & {
    //   margin-right: 40px;
    // }

    // .activeLoan & {
    //   margin-bottom: 24px;
    // }

    // .paidOffLoan &:first-child {
    //   margin-bottom: 16px;
    // }
  }

  // @media (max-width: 374px) {
  //    min-width: auto;
  // }

  a {
    color: ${(props) => props.theme.color.primary.v200};
    font-size: 16px;
    text-decoration: underline;
  }
`;

const BankInformationDetailsRight = styled.div`
  display: flex;
  align-items: flex-end;
  min-width: 110px;
  max-width: 100px;
  flex-direction: column;
  align-items: flex-start;
`;

const BankInformationLabel = styled.h4`
  color: ${(props) => props.theme.color.neutral.v500};
  padding: 0;
  margin: 0;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
`;

const BankInformationValue = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  display: flex;
`;

const BankInformationBankTextWrapper = styled.div`
  display: flex;
  align-items: center;

  a {
    font-size: 14px;
    line-height: 20px;
  }
`;

const BankInformationBankText = styled.div`
  align-items: center;
  display: flex;
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  display: flex;
`;

const BankInformationTitle = styled(BankInformationValue)``;

const BankInformationBankTextDivider = styled.span`
  margin: 0 7.5px;
  color: #757989;
`;

export {
  BankInformationWrapper,
  BridgecrestInformationWrapper,
  BankInformationCardLabel,
  BankInformationDetailsWrapper,
  BankInformationDetails,
  BankInformationDetailsRight,
  BankInformationTitle,
  BankInformationLabel,
  BankInformationValue,
  BankInformationDetailsContainer,
  BankInformationAccountNumberText,
  BankInformationBankText,
  BankInformationBankTextWrapper,
  BankInformationBankTextDivider,
};
